<template>
  <div class="tab-content">
    <div :class="{ 'active': activeTab == 'artworks' }">
      <ArtworksTab />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ArtworksTab from './artworks_tab/artworks_tab';

  export default {
    name: 'TabsContent',
    components: {
      ArtworksTab,
    },
    computed: {
      ...mapGetters(['activeTab']),
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/tabs_content.vue?e04ef96e